module.exports = __webpack_public_path__ + "static/img/4.28f50a9a.png";